/**
 * URL helpers for conversation (card) deep links.
 */

const CONVERSATION_DETAILS_PATH = 'Dashboard/ConversationDetails/#/';

function getWebBaseUrl(): string
{
  const weburl = (window as unknown as { config?: { weburl?: string } }).config?.weburl;

  if (typeof weburl === 'string' && weburl.trim() !== '')
  {
    const base = weburl.trim();

    // A localhost weburl points at the IIS-hosted client
    if (base.includes('localhost'))
    {
      return 'http://localhost/Corgee.WebClient/';
    }

    return base.endsWith('/') ? base : `${base}/`;
  }

  // window.config is only populated by MainLayout/Header
  const path = import.meta.env.BASE_URL || '/';
  return `${window.location.origin}${path.endsWith('/') ? path : `${path}/`}`;
}

/** Absolute URL of a card, or an empty string when there is no id. */
export function buildConversationDetailsUrl(conversationId: unknown): string
{
  if (conversationId === null || conversationId === undefined || conversationId === '')
  {
    return '';
  }

  return `${getWebBaseUrl()}${CONVERSATION_DETAILS_PATH}${conversationId}`;
}

/** Base URL for SPA deep links. `weburl` is used only when absolute. */
function getSpaBaseUrl(weburl?: string): string
{
  const candidate = (weburl ?? '').trim();

  if (/^https?:\/\//i.test(candidate))
  {
    return `${candidate.replace(/\/+$/, '')}/`;
  }

  const path = import.meta.env.BASE_URL || '/';
  return `${window.location.origin}${path.endsWith('/') ? path : `${path}/`}`;
}

/** Absolute URL of a dashboard, project-aware. */
export function buildDashboardUrl(
  dashboardId: number,
  projectId?: number,
  configValueId?: number,
  weburl?: string,
): string
{
  const base = getSpaBaseUrl(weburl);

  if (projectId)
  {
    return `${base}ProjectDetails/${projectId}?ProjectDashboardId=${dashboardId}`;
  }

  return `${base}Dashboard/${dashboardId}/${configValueId || 1}`;
}

/** Converts a number, DOM attribute string or `{ ConversationId }` into a numeric id. */
export function normalizeConversationId(value: unknown): number | null
{
  const raw =
    value !== null && typeof value === 'object'
      ? (value as { ConversationId?: unknown }).ConversationId
      : value;

  if (raw === null || raw === undefined || raw === '') return null;

  const id = Number(raw);
  return Number.isNaN(id) || id === 0 ? null : id;
}
